import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import { verification } from "@/api/passwords";
import { ApiError } from "@/api/http";
import { Card, CardBody, CardHeader } from "@/components/ui";

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState<"verifying" | "ok" | "error">("verifying");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setState("error");
      setError("Missing verification token.");
      return;
    }
    let alive = true;
    (async () => {
      try {
        await verification.verify(token);
        if (alive) setState("ok");
      } catch (e) {
        if (!alive) return;
        setState("error");
        setError(e instanceof ApiError ? e.message.replace(/^\d+:\s*/, "") : String(e));
      }
    })();
    return () => {
      alive = false;
    };
  }, [token]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 dark:bg-slate-950 p-4">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <h1 className="text-center text-base font-semibold">Email verification</h1>
        </CardHeader>
        <CardBody>
          {state === "verifying" && <p className="text-sm text-slate-500">Verifying…</p>}
          {state === "ok" && (
            <div className="space-y-2 text-sm">
              <p className="text-emerald-700 dark:text-emerald-300">Your email is verified.</p>
              <Link to="/login" className="text-brand">
                Sign in →
              </Link>
            </div>
          )}
          {state === "error" && (
            <div className="space-y-2 text-sm">
              <p className="text-red-700 dark:text-red-300">{error}</p>
              <Link to="/login" className="text-brand">
                Back to sign in →
              </Link>
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
}
